var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramStageTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 28,
    viewBox: "0 0 186 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_43050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 28H24.5009V3.49906H3.49906V28H0V0H28V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0019 27.9996H17.5028V11.0235H10.4972V27.9996H6.99811V7.52441H21.0019V27.9996Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_518_43050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4828 1.6084H55.326V26.3848H59.4828V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8119 1.6084H66.655V26.3848H70.8119V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4753 11.2157L56.7354 15.2344L58.0777 19.1812L69.8176 15.1625L68.4753 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6017 1.6416H36V5.81181H50.6017V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3825 3.72656H41.2257V26.3582H45.3825V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6613 28L73.6886 13.1461L82.8336 0L86.2383 2.38298L78.8022 13.0733L88 25.5177L84.6613 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3306 11.0283H76.2487V15.1985H86.3306V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_518_43050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.509 27.4838L149.859 15.4299L149.786 12.9277L158.598 0.509766L162.017 2.91922L154.109 14.053L160.946 22.592L165.123 15.9726L160.886 16.3102L160.554 12.1533L168.954 11.4913L170.889 14.6753L162.921 27.2984L159.509 27.4838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.323 26.339L138.998 8.70492L133.019 26.3059L129.055 24.9754L136.956 1.69499L138.705 1.67513L140.914 1.65527L149.267 24.9357L145.323 26.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.073 19.1329L139.166 16.2402L136.26 19.1329L139.166 22.0255L142.073 19.1329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.097 27.371L97.5231 24.0878L103.442 19.4873L96 10.4585L105.664 0.62207L108.657 3.54122L101.613 10.7034L109.395 20.1493L100.097 27.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 1.6416H112.833V5.81181H127.552V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.291 3.72656H118.101V26.3582H122.291V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.635 28L171.574 13.1461L180.792 0L184.224 2.38298L176.735 13.0733L186 25.5177L182.635 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.317 11.0283H174.155V15.1985H184.317V11.0283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_43050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_518_43050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_518_43050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 28,
    fill: "white",
    transform: "translate(96)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStageTab);
export default __webpack_public_path__ + "static/media/programStageTab.63956a7160eb70415b821e3a0c668d6f.svg";
export { ForwardRef as ReactComponent };